// extracted by mini-css-extract-plugin
module.exports = {"imglazy":"ImgLazy_imglazy__2DUUB","loaded":"ImgLazy_loaded__3xqMo"};